import styled from "styled-components";
import styledSystem from "helpers/styledSystem";

export const BaseWrap = styledSystem(styled.div`
  display: block;
  box-sizing: border-box;
  word-break: break-word;
`);
